/**
 *
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path typenames
 * @description Maps the type names to views
 * @evaluation bad
 * @category settings
 * @todo Should be moved to resources
 *
 */
const typenameToViewMap: Record<string, string> = {
  "Dubai Plan": "themes",
  "Governmetn Entity": "themes",
  "Government Entity": "themes",
  "People Theme": "theme",
  Theme: "theme",
  Aim: "aim",
  Priority: "aim",
  Gap: "",
  Program: "",
  Project: "project",
  Milestone: "",
  KPI: "kpidetails",
  "Experiene Theme": "theme",
  Society: "",
  Model: "",
  "Economy Theme": "theme",
  "Government Theme": "theme",
  "Place Theme": "theme",
  Scorecard: "",
  Sector: "sector",
  Subsector: "subsector",
  ["Sub-Sector"]: "subsector", // eslint-disable-line
};
export default typenameToViewMap;
